import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem("gs_user");
    return stored ? JSON.parse(stored) : null;
  });
  const [loading, setLoading] = useState(!!localStorage.getItem("gs_token"));

  useEffect(() => {
    let active = true;
    const token = localStorage.getItem("gs_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((res) => {
        if (!active) return;
        setUser(res.data);
        localStorage.setItem("gs_user", JSON.stringify(res.data));
      })
      .catch(() => {
        if (!active) return;
        localStorage.removeItem("gs_token");
        localStorage.removeItem("gs_user");
        setUser(null);
      })
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, []);

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    localStorage.setItem("gs_token", res.data.access_token);
    localStorage.setItem("gs_user", JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem("gs_token");
    localStorage.removeItem("gs_user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
